import { Button, Flex, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../utils";

// import { formatNumber } from "@utils/globalCommon";

interface TicketInputRightSectionProps {
  onClick(): void;
  label: string;
  tokenAmount: number;
  isConnected: boolean;
  token?: string;
  hideMax?: boolean;
}

const StableTicketInputBalance = ({
  label,
  tokenAmount,
  isConnected,
  onClick,
  token,
  hideMax = false,
}: TicketInputRightSectionProps) => {
  const { selectedERC20StableVault } = useSelector((state: any) => state.user);
  return (
    <Flex flexDir="column" alignItems="flex-start">
      {isConnected ? (
        <Flex gap="4px">
          <Text
            fontWeight="400"
            fontSize="12px"
            lineHeight={"14.4px"}
            letterSpacing={"0.5%"}
            mt="6px"
            color="textPrimary"
          >
            {label}:
          </Text>
          <Text
            fontWeight="700"
            fontSize="12px"
            lineHeight={"14.4px"}
            letterSpacing={"0.5%"}
            mt="6px"
            color="textPrimary"
          >
            {tokenAmount !== undefined && tokenAmount != null
              ? formatNumber(Number(tokenAmount), false, 4, true)
              : "-"}{" "}
            {token || selectedERC20StableVault}
          </Text>
          {!hideMax && (
            <Button
              bg="textPrimary"
              color="white"
              h="1.5rem"
              size="sm"
              p="4px 8px"
              _hover={{
                bg: "textPrimary",
              }}
              onClick={() => onClick()}
              w="41px"
              fontWeight="700"
              fontSize="10px"
              borderRadius="8px"
            >
              MAX
            </Button>
          )}
        </Flex>
      ) : null}
    </Flex>
  );
};

export default StableTicketInputBalance;
